import { createContext } from 'react'

export type InspectorContextProps = {
  enabled: boolean
}
export const InspectorContext = createContext<InspectorContextProps | undefined>(undefined)
